/* Monsor bundel-set
   - schakelaars per product
   - live subtotaal, korting (display) en besparing
   - voegt de geselecteerde producten in één keer toe via de thema-route
   - opent daarna de cart drawer, net als de eigen productformulieren
   De werkelijke korting wordt door Shopify (automatische korting) of de bundel-app
   toegepast. Het percentage hier is voor de weergave op de productpagina. */
(function () {
  function eur(cents) {
    return '\u20ac' + (cents / 100).toFixed(2).replace('.', ',');
  }

  function initBundle(root) {
    if (root.dataset.bsInit) return;
    root.dataset.bsInit = '1';

    var pct = parseFloat(root.getAttribute('data-discount')) || 0;
    var min = parseInt(root.getAttribute('data-min'), 10) || 1;
    var rows = Array.prototype.slice.call(root.querySelectorAll('[data-bs-row]'));
    var totalEl = root.querySelector('[data-bs-total]');
    var origEl = root.querySelector('[data-bs-orig]');
    var saveEl = root.querySelector('[data-bs-save]');
    var cta = root.querySelector('[data-bs-cta]');
    if (!cta) return;
    var ctaLabel = cta.getAttribute('data-cta-label') || 'Voeg set toe';
    var ctaSpan = cta.querySelector('.btn-text > span') || cta;

    function recalc() {
      var sub = 0;
      var n = 0;
      rows.forEach(function (r) {
        if (r.getAttribute('data-on') === 'true') {
          sub += parseInt(r.getAttribute('data-price'), 10) || 0;
          n += 1;
        }
      });
      var disc = n >= min ? Math.round((sub * pct) / 100) : 0;
      var total = sub - disc;

      if (n === 0) {
        ctaSpan.textContent = 'Kies een product';
        cta.setAttribute('aria-disabled', 'true');
        if (totalEl) totalEl.textContent = '';
        if (origEl) origEl.textContent = '';
        if (saveEl) saveEl.textContent = '';
        return;
      }

      cta.removeAttribute('aria-disabled');
      if (totalEl) totalEl.textContent = eur(total);
      ctaSpan.textContent = ctaLabel + ' \u00b7 ' + eur(total);

      if (disc > 0) {
        if (origEl) {
          origEl.style.display = '';
          origEl.textContent = eur(sub);
        }
        if (saveEl) {
          saveEl.style.display = '';
          saveEl.classList.remove('is-muted');
          saveEl.textContent = 'Je bespaart ' + eur(disc);
        }
      } else {
        if (origEl) origEl.style.display = 'none';
        if (saveEl) {
          saveEl.style.display = '';
          saveEl.classList.add('is-muted');
          saveEl.textContent = 'Vanaf ' + min + ' producten: ' + pct + '% set-voordeel';
        }
      }
    }

    rows.forEach(function (r) {
      var sw = r.querySelector('.monsor-bs__sw');
      if (!sw) return;
      sw.addEventListener('click', function () {
        var on = r.getAttribute('data-on') === 'true';
        r.setAttribute('data-on', on ? 'false' : 'true');
        sw.setAttribute('aria-checked', on ? 'false' : 'true');
        recalc();
      });
    });

    cta.addEventListener('click', function () {
      if (cta.getAttribute('aria-disabled') === 'true') return;
      if (cta.getAttribute('aria-busy') === 'true') return;

      var items = rows
        .filter(function (r) { return r.getAttribute('data-on') === 'true'; })
        .map(function (r) { return { id: r.getAttribute('data-vid'), quantity: 1 }; });
      if (!items.length) return;

      var hasTheme = typeof theme !== 'undefined' && theme.routes && theme.routes.cart_add_url;
      var addUrl = hasTheme ? theme.routes.cart_add_url : '/cart/add.js';
      var cartUrl = hasTheme && theme.routes.cart_url ? theme.routes.cart_url : '/cart.js';

      var sectionsToBundle = [];
      document.documentElement.dispatchEvent(
        new CustomEvent('cart:bundled-sections', { bubbles: true, detail: { sections: sectionsToBundle } })
      );

      var cfg = hasTheme
        ? theme.utils.fetchConfig('javascript')
        : { method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/javascript' } };
      cfg.body = JSON.stringify({
        items: items,
        sections: sectionsToBundle,
        sections_url: window.location.pathname
      });

      cta.setAttribute('aria-busy', 'true');

      fetch(addUrl, cfg)
        .then(function (response) { return response.json(); })
        .then(function (parsed) {
          if (parsed.status) {
            cta.removeAttribute('aria-busy');
            return null;
          }
          var getCfg = hasTheme
            ? theme.utils.fetchConfig('json', 'GET')
            : { method: 'GET', headers: { 'Accept': 'application/json' } };
          return fetch(cartUrl, getCfg)
            .then(function (r) { return r.json(); })
            .then(function (cartJson) {
              cartJson.sections = parsed.sections;
              if (hasTheme && theme.pubsub && theme.pubsub.PUB_SUB_EVENTS) {
                theme.pubsub.publish(theme.pubsub.PUB_SUB_EVENTS.cartUpdate, {
                  source: 'monsor-bundle',
                  cart: cartJson
                });
              }
              document.dispatchEvent(new CustomEvent('ajaxProduct:added', { detail: { product: parsed } }));
              var drawer = document.querySelector('cart-drawer');
              if (drawer && typeof drawer.show === 'function') {
                drawer.show(cta);
              } else {
                document.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true, detail: { open: true } }));
              }
              cta.removeAttribute('aria-busy');
            });
        })
        .catch(function (error) {
          console.log('monsor-bundle', error);
          cta.removeAttribute('aria-busy');
        });
    });

    recalc();
  }

  function initAll() {
    document.querySelectorAll('.monsor-bs').forEach(initBundle);
  }

  if (document.readyState !== 'loading') {
    initAll();
  } else {
    document.addEventListener('DOMContentLoaded', initAll);
  }
  document.addEventListener('shopify:section:load', initAll);
})();